import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectNewProfileTypeProps } from './SelectNewProfileType';
import {
  Button,
  Icon,
  SocialMediaIcon,
  SocialMediaIconProps,
} from '@kontentino/ui';
import PageTypeUtils from 'app/utils/pageType';
import { faCircleEllipsis } from '@fortawesome/pro-regular-svg-icons/faCircleEllipsis';
import { getYtLogoGuidelineSize } from 'app/utils/getytlogoguidelinesize';
export type NewManualProfileCardProps = {
  type: number | 'other';
  dataCy?: string;
  dataName?: string;
} & Pick<SelectNewProfileTypeProps, 'openManualForm'>;

const NewManualProfileCard: FC<NewManualProfileCardProps> = ({
  type,
  openManualForm,
  dataCy,
  dataName,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className="tw-flex tw-h-[44px] tw-items-center tw-justify-between tw-rounded-md tw-border tw-border-grayscale-20 tw-bg-white tw-px-3 tw-py-2"
      data-cy={dataCy}
      data-name={dataName}
    >
      <div className="tw-flex tw-items-center tw-space-x-2">
        {type === 'other' ? (
          <Icon
            icon={faCircleEllipsis}
            className="tw-text-grayscale-50"
            size="lg"
          />
        ) : (
          <SocialMediaIcon
            type={PageTypeUtils.getName(type) as SocialMediaIconProps['type']}
            variant="plain"
            size={getYtLogoGuidelineSize(20, type)}
          />
        )}

        <span>
          {type === 'other'
            ? t('newSocialMediaProfile.other')
            : PageTypeUtils.getLabel(type)}
        </span>
      </div>
      <Button
        variant="tertiary"
        onClick={() => openManualForm?.(type === 'other' ? undefined : type)}
        size="small"
        className="tw-w-[86px]"
      >
        {t('newSocialMediaProfile.create')}
      </Button>
    </div>
  );
};

export default NewManualProfileCard;
